import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_67: DocMigration = {
  maxSchemaVersion: "0.0.67",
  description: "Refactor DocEntityBase to include an entityType field",
  apply(json: any) {
    migrateModelToIncludeEntityType(json, {
      blocks: "BLOCK",
      stairBlocks: "STAIR_BLOCK",
      stairSystems: "STAIR_SYSTEM",
      roofSystems: "ROOF_SYSTEM",
      rooms: "ROOM",
      roofs: "ROOF",
      underlays: "UNDERLAY",
      referenceGeom: "REFERENCE_GEOM",
      elevations: "ELEVATION",
      palettes: "PALETTE",
      settings: "SHEET",
      drawingRefs: "DRAWING_REF",
      facades: "FACADE",
    });
    return json;
  },
};

function migrateModelToIncludeEntityType(doc: any, migratedFields: { [field: string]: any }) {
  for (const field in doc) {
    const entityType = migratedFields[field];
    if (!entityType) {
      continue;
    }
    const entities: any[] = Object.values(doc[field]);
    entities.forEach((entity) => {
      if (doc[field][entity.id]) {
        doc[field][entity.id].entityType = entityType;
      }
    });
  }
}

export default migration_0_0_67;
